import { useState, useCallback } from 'react';
import api from '../services/api';

/**
 * Hook for managing plans across databases
 */
export function usePlans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Get consolidated plans (from all databases)
   */
  const listConsolidated = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const { data } = await api.get('/companies/consolidated/plans');
      setPlans(data.data || []);
      return data.data || [];
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      setError(message);
      console.error('Failed to list consolidated plans:', message);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  /**
   * Get plans from a specific database
   */
  const listByDatabase = useCallback(async (databaseId) => {
    try {
      setLoading(true);
      setError(null);
      const { data } = await api.get(`/companies/${databaseId}/plans`);
      setPlans(data.data || []);
      return data.data || [];
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      setError(message);
      console.error('Failed to list plans:', message);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    plans,
    loading,
    error,
    listConsolidated,
    listByDatabase,
  };
}
